// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/fonts/fonts.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sidebar-width: 260px;
  --sidebar-width-tablet: 220px;
  --color-navy: #174078;
  --color-orange: #f97316;
  --color-border: #e5e7eb;
  --color-bg: #f9fafb;
  --page-padding-x: 40px;
  --page-padding-y: 30px;
  --radius-md: 8px;
  --radius-lg: 12px;
}

* {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color-navy);
  font-family: 'aeonikfont', sans-serif;
  background-color: var(--color-bg);
}
/* src/index.css */

/* ... after the body styles ... */

/* --- GLOBAL SCROLLBAR STYLES --- */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #FF6600; /* THE CORRECT ORANGE COLOR */
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #e65c00; /* A slightly darker orange for hover */
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAGA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;EAClC,wBAAwB;EACxB,qCAAqC;EACrC,iCAAiC;AACnC;AACA,kBAAkB;;AAElB,kCAAkC;;AAElC,oCAAoC;AACpC;EACE,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,mBAAmB,EAAE,6BAA6B;EAClD,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB,EAAE,uCAAuC;AAC9D","sourcesContent":["@import './assets/fonts/fonts.css';\n@import './styles/shared.css';\n\n:root {\n  --sidebar-width: 260px;\n  --sidebar-width-tablet: 220px;\n  --color-navy: #174078;\n  --color-orange: #f97316;\n  --color-border: #e5e7eb;\n  --color-bg: #f9fafb;\n  --page-padding-x: 40px;\n  --page-padding-y: 30px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}\n\nbody {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: var(--color-navy);\n  font-family: 'aeonikfont', sans-serif;\n  background-color: var(--color-bg);\n}\n/* src/index.css */\n\n/* ... after the body styles ... */\n\n/* --- GLOBAL SCROLLBAR STYLES --- */\n::-webkit-scrollbar {\n  width: 8px;\n}\n\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #FF6600; /* THE CORRECT ORANGE COLOR */\n  border-radius: 4px;\n}\n\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #e65c00; /* A slightly darker orange for hover */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
